import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import SEO from '../components/common/SEO';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { loginUser, clearError } from '../store/slices/authSlice';

export default function LoginPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((s) => s.auth);
  const [form, setForm] = useState({ email: '', password: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(clearError());
    const result = await dispatch(loginUser(form));
    if (loginUser.fulfilled.match(result)) {
      toast.success(t('auth.welcomeBack'));
      navigate('/dashboard');
    } else {
      toast.error(result.payload || 'Login failed');
    }
  };

  return (
    <>
      <SEO title={t('auth.login')} />
      <section className="min-h-[70vh] flex items-center justify-center px-4 py-12">
        <div className="card w-full max-w-md">
          <h1 className="text-2xl font-display font-bold text-center mb-6">{t('auth.login')}</h1>
          {loading ? <LoadingSpinner /> : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <input type="email" className="input-field" placeholder={t('auth.email')} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
              <input type="password" className="input-field" placeholder={t('auth.password')} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
              {error && <p className="text-red-500 text-sm">{error}</p>}
              <button type="submit" className="btn-primary w-full">{t('auth.login')}</button>
            </form>
          )}
          <p className="text-center mt-4 text-sm text-gray-500">
            {t('auth.noAccount')} <Link to="/register" className="text-brand-600 font-semibold">{t('auth.register')}</Link>
          </p>
        </div>
      </section>
    </>
  );
}
